/*
 * @FilePath: admin-merchant.js
 * @Author: 旭颖
 * @Date: 2023-06-19 09:58:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-26 19:42:55
 */
import axios from "@/plugins/axios";

export function getUser() {
    return axios.get("admin_user");
}

export function getAdminUsers(params = {}) {
    return axios.get("admin_merchants", { params });
}

export function storeAdminUser(data) {
    return axios.post("admin_merchants", data);
}

export function destroyAdminUser(id) {
    return axios.delete(`admin_merchants/${id}`);
}

export function updateAdminUser(id, data) {
    return axios.put(`admin_merchants/${id}`, data);
}

export function showAdminUser(id) {
    return axios.get(`admin_merchants/${id}`);
}

export function editAdminUser(id) {
    return axios.get(`admin_merchants/${id}/edit`);
}

export function editUser() {
    return axios.get("admin_user/edit");
}

export function updateUser(data) {
    return axios.put("admin_user", data);
}

export function getAreaAdminUsers(params = {}) {
    return axios.get("admin_user/areaAdmin", { params });
}

export function getAdminUsersMerchant(params = {}) {
    return axios.get("admin_merchants", { params });
}
export function getMerchantConfig(params = {}) {
    return axios.get("admin_merchant_config/get", { params });
}
export function editMerchantConfig(data) {
    return axios.post("admin_merchant_config/edit", data);
}
export function getTypeList(params = {}) {
    return axios.get("pay-merchants/type-select-options", { params });
}
export function getMerchantList() {
    return axios.get("/pay-merchants/select-options");
}
